import { render, staticRenderFns } from "./info-screening-patient.vue?vue&type=template&id=7691e864&scoped=true&"
import script from "./info-screening-patient.vue?vue&type=script&lang=js&"
export * from "./info-screening-patient.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-patient.vue?vue&type=style&index=0&id=7691e864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7691e864",
  null
  
)

export default component.exports